// import { Link } from "react-router-dom";
// import "./NavigationStyle.css";
// import { useAuthContext } from "../../hooks/useAuthContext";
// import logo from "../../assets/images/mahmoudosman-logo.png";

// const NavigationComponent = () => {
//   const { user } = useAuthContext();
//   return (
//     <section className="navigation">
//       <nav className="navbar navbar-expand-lg navbar-light bg-light">
//         <div className="container-fluid">
//           <Link to="/" className="navbar-brand">
//             <img className="img-fluid logo-image" src={logo} alt="logo" />
//           </Link>
//           <button
//             className="navbar-toggler"
//             type="button"
//             data-bs-toggle="collapse"
//             data-bs-target="#navbarNav"
//             aria-controls="navbarNav"
//             aria-expanded="false"
//             aria-label="Toggle navigation"
//           >
//             <span className="navbar-toggler-icon" />
//           </button>
//           <div className="collapse navbar-collapse" id="navbarNav">
//             <ul className="navbar-nav ms-auto">
//               <li className="nav-item">
//                 <Link className="nav-link" to="/">
//                   Home
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link" to="/api/portfolio">
//                   Portfolio
//                 </Link>
//               </li>
//               <li className="nav-item">
//                 <Link className="nav-link" to="/api/about">
//                   About
//                 </Link>
//               </li>

//               {user && (
//                 <li className="nav-item">
//                   <Link className="nav-link" to="/api/dashboard">
//                     Dashboard
//                   </Link>
//                 </li>
//               )}

//               <li className="nav-item">
//                 <Link className="nav-link" to="/api/courses">
//                   Courses
//                 </Link>
//               </li>

//               <li className="nav-item">
//                 <Link className="nav-link" to="/api/blogs">
//                   Blogs
//                 </Link>
//               </li>

//               {/*=============== Jobs=============== */}
//               {user?.isAdmin && user.supperAdmin && (
//                 <li className="nav-item dropdown">
//                   <a
//                     className="nav-link dropdown-toggle"
//                     href="#"
//                     role="button"
//                     data-bs-toggle="dropdown"
//                     aria-expanded="false"
//                   >
//                     Jobs
//                   </a>

//                   <ul className="dropdown-menu">
//                     <li>
//                       <Link className="dropdown-item" to="/api/jobs/all-jobs">
//                         Job List
//                       </Link>
//                     </li>
//                     {user?.isAdmin && user.supperAdmin && (
//                       <li>
//                         <Link
//                           className="dropdown-item"
//                           to="/api/jobs/add-new-job"
//                         >
//                           Add Jobs
//                         </Link>
//                       </li>
//                     )}

//                     {/* /api/jobs/applications */}

//                     {user?.isAdmin && user.supperAdmin && (
//                       <li>
//                         <Link
//                           className="dropdown-item"
//                           to="/api/jobs/applications"
//                         >
//                           Applications
//                         </Link>
//                       </li>
//                     )}
//                   </ul>
//                 </li>
//               )}

//               {/* {user?.isAdmin && ( */}
//               <li className="nav-item">
//                 <Link className="nav-link" to="/api/get-in-touch/contact">
//                   Contact
//                 </Link>
//               </li>
//               {/* )} */}

//               {user?.isAdmin && (
//                 <li className="nav-item">
//                   <Link className="nav-link" to="/api/dashboard/create">
//                     Add Blog
//                   </Link>
//                 </li>
//               )}

//               {user?.isAdmin && (
//                 <li className="nav-item">
//                   <Link className="nav-link" to="/api/dashboard/add-course">
//                     Add Course
//                   </Link>
//                 </li>
//               )}

//               {!user && (
//                 <li className="nav-item">
//                   <Link className="nav-link bg-warning" to="api/users/login">
//                     Login
//                   </Link>
//                 </li>
//               )}
//             </ul>
//           </div>
//         </div>
//       </nav>
//     </section>
//   );
// };

// export default NavigationComponent;

import { Link } from "react-router-dom";
import { useAuthContext } from "../../hooks/useAuthContext";
import logo from "../../assets/images/mahmoudosman-logo.png";
import "./NavigationStyle.css"; // We'll create this CSS file

const NavigationComponent = () => {
  const { user } = useAuthContext();

  return (
    <header className="navbar-glass">
      <nav className="navbar navbar-expand-lg">
        <div className="container">
          <Link to="/" className="navbar-brand">
            <img className="nav-logo" src={logo} alt="logo" />
            {/* <span className="brand-name">Mahmoud Osman</span> */}
          </Link>

          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="collapse"
            data-bs-target="#navbarNav"
            aria-controls="navbarNav"
            aria-expanded="false"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div className="collapse navbar-collapse" id="navbarNav">
            <ul className="navbar-nav ms-auto">
              <NavItem to="/" icon="home" text="Home" />
              <NavItem to="/api/portfolio" icon="briefcase" text="Portfolio" />
              <NavItem to="/api/about" icon="person" text="About" />

              {user && (
                <NavItem
                  to="/api/dashboard"
                  icon="speedometer2"
                  text="Dashboard"
                />
              )}

              <NavItem to="/api/courses" icon="book" text="Courses" />
              <NavItem to="/api/blogs" icon="newspaper" text="Blogs" />

              {user?.isAdmin && user.supperAdmin && (
                <li className="nav-item dropdown">
                  <DropdownMenu
                    icon="briefcase-fill"
                    text="Jobs"
                    items={[
                      {
                        to: "/api/jobs/all-jobs",
                        icon: "list-ul",
                        text: "Job List",
                      },
                      {
                        to: "/api/jobs/add-new-job",
                        icon: "plus-circle",
                        text: "Add Jobs",
                      },
                      {
                        to: "/api/jobs/applications",
                        icon: "people",
                        text: "Applications",
                      },
                    ]}
                  />
                </li>
              )}

              <NavItem
                to="/api/get-in-touch/contact"
                icon="envelope"
                text="Contact"
              />

              {user?.isAdmin && (
                <>
                  <NavItem
                    to="/api/dashboard/create"
                    icon="file-earmark-plus"
                    text="Add Blog"
                  />
                  <NavItem
                    to="/api/dashboard/add-course"
                    icon="journal-plus"
                    text="Add Course"
                  />
                </>
              )}

              {!user ? (
                <li className="nav-item ms-lg-3">
                  <Link className="nav-login-btn" to="api/users/login">
                    <i className="bi bi-box-arrow-in-right me-2"></i> Login
                  </Link>
                </li>
              ) : (
                <li className="nav-item dropdown ms-lg-3">
                  <UserDropdown user={user} />
                </li>
              )}
            </ul>
          </div>
        </div>
      </nav>
    </header>
  );
};

// Reusable NavItem component
const NavItem = ({ to, icon, text }) => (
  <li className="nav-item">
    <Link className="nav-link" to={to}>
      <i className={`bi bi-${icon} nav-icon`}></i>
      <span className="nav-text">{text}</span>
    </Link>
  </li>
);

// Reusable Dropdown component
const DropdownMenu = ({ icon, text, items }) => (
  <>
    <a
      className="nav-link dropdown-toggle"
      href="#"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <i className={`bi bi-${icon} nav-icon`}></i>
      <span className="nav-text">{text}</span>
    </a>
    <ul className="dropdown-menu glass-dropdown">
      {items.map((item, index) => (
        <li key={index}>
          <Link className="dropdown-item" to={item.to}>
            <i className={`bi bi-${item.icon} me-2`}></i>
            {item.text}
          </Link>
        </li>
      ))}
    </ul>
  </>
);

// User dropdown component
const UserDropdown = ({ user }) => (
  <>
    <a
      className="nav-link user-avatar"
      href="#"
      role="button"
      data-bs-toggle="dropdown"
      aria-expanded="false"
    >
      <div className="avatar-circle">
        {user.firstName.charAt(0).toUpperCase()}
      </div>
    </a>
    <ul className="dropdown-menu dropdown-menu-end glass-dropdown">
      <li>
        <Link className="dropdown-item" to="/api/profile">
          <i className="bi bi-person me-2"></i> Profile
        </Link>
      </li>
      <li>
        <Link className="dropdown-item" to="/api/settings">
          <i className="bi bi-gear me-2"></i> Settings
        </Link>
      </li>
      <li>
        <hr className="dropdown-divider" />
      </li>
      <li>
        <Link className="dropdown-item" to="/api/logout">
          <i className="bi bi-box-arrow-right me-2"></i> Logout
        </Link>
      </li>
    </ul>
  </>
);

export default NavigationComponent;
